import { ReactNode } from 'react';

import { useResourceLinkExtensions } from '../../extensions';

export interface ResourceNameLinkProps {
  name: string;
  text: ReactNode;
}

export const ResourceNameLink = (props: ResourceNameLinkProps) => {
  const { name, text } = props;

  const extensions = useResourceLinkExtensions();

  const extension = extensions.find(e => e.predicate({ name, text }));
  if (extension) {
    return extension.render({ name, text });
  }

  return <strong data-resource-ref={name}>{text}</strong>;
};
